const FRANCHISE_REGEX = /^\/([\w|\d|-]+)/;

export function buildRoute(url, route) {
  const franchise = url.match(FRANCHISE_REGEX);
  if (!franchise) return route;
  return `/${franchise[1]}${route}`;
}



// WEBPACK FOOTER //
// ./src/routes.js